import http from '@/config/api';
import router from '@/router';

export default {
  setContactInfo({ commit }, payload) {
    return commit('SET_CONTACT_INFO', payload);
  },
  async submitTicket(_, payload){
    const directory = router.currentRoute.value?.params.directory;
    const apiLink = directory ? `event/${directory}/contact` : '/contact';
    const response = await http.post(apiLink, payload).then(
      (res) => res,
      (err) => ({
        error : {
          ...err
        }
      })
    );
    return response;
  }
};
